<template>
<v-row align="center" justify="space-between" class="list-action-panel_body py-0" no-gutters>
    <div class="check-selecting">
      <v-col v-show="isCheckable" class="checkbox-icon">
        <v-icon
          v-if="allChecked"
          color="#757575"
          @click="handleToggleCheckAll"
          size="20"
        >
          <!-- check_box -->
          fas fa-check-circle
        </v-icon>
        <v-icon
          v-else-if="someChecked"
          color="#757575"
          @click="handleToggleCheckAll"
          size="20"
        >
          <!-- indeterminate_check_box -->
          fas fa-minus-circle
        </v-icon>
        <v-icon
          v-else
          color="#757575"
          @click="handleToggleCheckAll"
          size="20"
        >
          <!-- check_box_outline_blank -->
          far fa-circle
        </v-icon>
      </v-col>
      <v-col v-if="checkedOnPageCount > 0">
        <span>Selected: {{checkedOnPageCount}}</span>
      </v-col>
    </div>
    <v-col class="list-action-panel_actions pb-1">
      <v-tooltip bottom
        v-for="(action, index) in actions"
        :key="index"
      >
        <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            class="ma-1"
            @click="action.callback()"
            icon small
            :loading="action.loading"
          >
            <v-icon :size="action.iconSize" color="#757575">
              {{action.icon}}
            </v-icon>
          </v-btn>
        </template>
        <span>{{action.tooltip}}</span>
      </v-tooltip>
      <slot name="extraButtons"></slot>
    </v-col>
    <div v-if="wrld !== null" class="pagination pr-2">
        <div
          class="pagination_list"
        >
          <span>{{pageResultsPagination.pageStart | filterIsNaN}} - {{pageResultsPagination.pageEnd | filterIsNaN}} {{$t('general.of')}} {{pageResultsPagination.totalResults | filterIsNaN}}</span>
          <v-btn
            fab depressed
            :disabled="isFirstPage"
            @click="handlePreviousPage"
          >
            <v-icon>keyboard_arrow_left</v-icon>
          </v-btn>
          <v-btn
            fab depressed
            :disabled="isLastPage"
            @click="handleNextPage"
          >
            <v-icon>keyboard_arrow_right</v-icon>
          </v-btn>
        </div>
    </div>
  </v-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'WrldListActionPanel',
  props: {
    actions: Array,
    isCheckable: { type: Boolean, default: true },
    wrld: { type: Object, default: () => null }
  },
  data () {
    return {}
  },
  mounted () {
  },
  computed: {
    ...mapGetters({
      getCheckedOnPageCount: 'getCheckedOnPageCount',
      getCheckedOnPage: 'getCheckedOnPage',
      getResourceOverviewList: 'getResourceOverviewList',
      getSearchQuery: 'getSearchQuery',
      getCheckedFacets: 'getCheckedFacets',
      getActualListPage: 'getActualListPage',
      getTotalNumberOverviewList: 'getTotalNumberOverviewList',
      getPaginationLimit: 'pagination/getPaginationLimit',
      getPaginationTotal: 'pagination/getPaginationTotal',
      getPaginationPage: 'pagination/getPaginationPage'
  }),
    checkedOnPageCount () {
      return this.getCheckedOnPageCount(this.actualPage)
    },
    checkedOnPage () {
      return this.getCheckedOnPage(this.actualPage)
    },
    actualPage () {
      return this.getPaginationPage
    },
    total () {
      return this.getPaginationTotal
    },
    allChecked () {
      return this.checkedOnPageCount === this.getResourceOverviewList.length
    },
    someChecked () {
      return this.checkedOnPageCount > 0 && this.checkedOnPageCount < this.getResourceOverviewList.length
    },
    isFirstPage () {
      return this.actualPage === 0
    },
    isLastPage () {
      return this.total <= (this.wrld.pageSize * (this.actualPage + 1))
    },
    pageResultsPagination () {
      if (this.isLastPage) {
        return { pageStart: this.wrld.pageSize * (this.actualPage + 1) - (this.wrld.pageSize - 1), pageEnd: this.total, totalResults: this.total}
      }
      return { pageStart: this.wrld.pageSize * (this.actualPage + 1) - (this.wrld.pageSize - 1), pageEnd: this.wrld.pageSize * (this.actualPage + 1), totalResults: this.total }
    }
  },
  methods: {
    ...mapActions({
      toggleCheckAll: 'toggleCheckAll',
      changeListPage: 'changeListPage',
      setResourceOverviewList: 'setResourceOverviewList',
      setFilterQuery: 'setFilterQuery',
      setPaginationPage: 'pagination/setPaginationPage',
      setPaginationIndex: 'pagination/setPaginationIndex',
    }),
    handleToggleCheckAll () {
      this.toggleCheckAll({ page: this.actualPage, hitsOnPage: this.getResourceOverviewList })
    },
    handleNextPage () {
      const page = (this.actualPage + 1)
      this.setPaginationPage({ index: this.wrld.index, page })
      // this.setResourceOverviewList({ index: this.wrld.index, query: this.getSearchQuery, filters: this.getCheckedFacets, page, pageSize: this.wrld.pageSize })
      // this.setFilterQuery({ queryArrayFacet: this.getCheckedFacets, queryPage: page, querySearchText: this.getSearchQuery })
    },
    handlePreviousPage () {
      const page = (this.actualPage - 1)
      this.setPaginationPage({ index: this.wrld.index, page })
      // this.setResourceOverviewList({ index: this.wrld.index, query: this.getSearchQuery, filters: this.getCheckedFacets, page, pageSize: this.wrld.pageSize })
      // this.setFilterQuery({ queryArrayFacet: this.getCheckedFacets, queryPage: page, querySearchText: this.getSearchQuery })
    }
  }
}
</script>

<style lang="scss" scoped>
.list-action-panel_body {
    height: 100%;
    // padding-left: 24px;
  }
  .check-selecting {
    display: inline-flex;
    span, .v-flex {
      color: #757575;
      font-weight: 500;
      padding-top: 2px;
      display: inline-block;
    }
  }
  .pagination {
    display: inline-block;
    span {
      display: inline-block;
    }
  }
  .pagination_list {
    font-size: 18px;
    .v-btn {
      width: 25px;
      height: 25px;
      margin: 0 0 0 16px;
    }
    span {
      font-size: 16px;
    }
  }
  .checkbox-icon{
    .v-icon {
      padding-left: 24px;
      padding-right: 8px;
    }
  }
</style>
